import { useEffect, useState, useRef } from 'react';

export default function PageViewCounter() {
  const [count, setCount] = useState<number>(0);
  const hasIncremented = useRef(false);

  useEffect(() => {
    if (hasIncremented.current) return;
    hasIncremented.current = true;

    const key = '1mindlab_pageview_lifetime';
    const stored = parseInt(localStorage.getItem(key) || '0', 10);
    const next = stored + 1;
    localStorage.setItem(key, String(next));
    setCount(next);
  }, []);

  return (
    <div className="w-full text-center py-3 text-[10px] md:text-[11px] text-foreground-400 tracking-wider font-medium">
      你是第 <span className="font-mono text-foreground-500 tabular-nums">{count.toLocaleString()}</span> 位到訪者
      <span className="mx-2 text-foreground-300">·</span>
      1mindlab
    </div>
  );
}